import React from 'react'
import powerbod from '../assets/logo'
import { Link } from 'react-router-dom'
import { FaOpencart } from "react-icons/fa";
import { useState, useEffect } from 'react';

const Navbar = (props) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlNavbar = () => {
    if (window.scrollY > lastScrollY) {
      // If scrolling down, hide navbar
      setIsVisible(false);
    } else {
      // If scrolling up, show navbar
      setIsVisible(true);
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);
  return (
    <div>
      <div className='flex items-center m-3'>
        {/* Large screen Navbar */}
        <div className='static border-2 border-gray-200 w-full p-4 rounded-full hidden lg:flex items-center justify-between gap-6 shadow-lg bg-white'>
    {/* Logo */}
    <div className='flex items-center'>
        <img src={powerbod} alt="Logo" className='rounded-full w-[50px]' />
    </div>
    
    {/* Navigation List */}
    <div className='flex gap-6 items-center text-lg font-medium text-gray-800'>
        <Link to="/" className='hover:text-blue-700 transition-colors duration-300'>Home</Link>
        <Link to="/Order" className='hover:text-blue-700 transition-colors duration-300'>Products</Link>
        <Link to="/contact" className='hover:text-blue-700 transition-colors duration-300'>Contact</Link>
    </div>
    
    {/* Action Buttons */}
    <div className='flex items-center gap-6'>
        <Link to="/cart">
            <button className='flex flex-col items-center justify-center text-gray-800 hover:text-blue-700 transition duration-300'>
                {props.cartNo}
                <FaOpencart size={30} />
            </button>
        </Link>
        <Link to="/contact"><button className='bg-blue-700 text-white px-5 py-2 rounded-full hover:bg-blue-800 transition duration-300'>
            Contact Us
        </button>
        </Link>
    </div>
</div>

        {/* Mobile  */}
        <div
      className={`flex lg:hidden z-20 navbar items-center justify-center fixed bottom-0 w-full bg-white shadow-md transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
            {/* logo */}
            <Link to="/"><div>
                <img src={powerbod} alt="" className='rounded-full w-[45px]'/>
            </div></Link>
            {/* list */}
            <div className='flex gap-3 items-center justify-center text-xl text-black'>
                <Link to="/" ><span>Home</span></Link>
                <Link to="/Order"><span>Products</span></Link>
                <Link to="/contact"><span>Contacts</span></Link>
            </div>
            <div className='flex items-center justify-between p-2 gap-5'>
                <Link to="/cart"><button className='flex flex-col items-center justify-center'>{props.cartNo}<FaOpencart size={30}/></button></Link>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
